import React from 'react';
import { Button, Layout } from 'antd';
import { Link } from 'react-router-dom';
import GroupsList from './components/GroupsList';

const layout_position = { padding: '0 4%' };

export default function Index() {
    return (
        <Layout style={layout_position}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                    <h3 className="page-title">Groups</h3>
                    <h3 className="page-subhead subhead">Control permissions within the SuperBike Factory platform</h3>
                </div>
                <div style={{ marginTop: 20 }}>
                    <Link to="/UserManagement/User_group_create">
                        <Button type="primary">Add New Group</Button>
                    </Link>
                </div>
            </div>
            <GroupsList />
        </Layout>
    );
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group/index.js